import React from "react";
import Order from "../orders/Order";

function WorkOrder() {
  return <Order whichOrder={"workOrder"} />;
}

export default WorkOrder;
